import React from "react";
import { useTranslation } from "react-i18next";

import useChannelInfo from "../../hooks/useChannelInfo.js";
import Button from "../Button/Button.js";
import EmbellishedHeading from "../EmbellishedHeading/EmbellishedHeading.js";
import Flyout from "../Flyout/Flyout.js";
import RequiresViewerLink from "../RequiresViewerLink/RequiresViewerLink.js";
import Stack from "../Stack/Stack.js";

import "./Raffle.scss";
import SubtleText from "../SubtleText/SubtleText.js";

const Raffle = ({
  activeRaffle,
  hasFollower,
  onDismissRaffle,
  onPermanentlyDismissRaffle,
  onEnterRaffle,
}) => {
  const { channel_name } = useChannelInfo();
  const { t } = useTranslation();

  return (
    <Flyout direction="bottom">
      <div style={{ textAlign: "center", maxWidth: "40rem", margin: "0 auto" }}>
        <Stack vertical>
          <EmbellishedHeading>
            {t("features.followers.rafflePopup.title", {
              channelName: channel_name,
            })}
          </EmbellishedHeading>
          <p>{t("features.followers.rafflePopup.message")}</p>
          {hasFollower && (
            <Stack vertical spacing="default">
              <SubtleText>
                <small>
                  {t("features.followers.rafflePopup.existingFollowerMessage", {
                    channelName: channel_name,
                  })}
                </small>
              </SubtleText>
              <Button variant="secondary" onClick={onPermanentlyDismissRaffle}>
                {t(
                  "features.followers.rafflePopup.actions.permanentlyDismissRaffle"
                )}
              </Button>
              {/*<Stack horizontal spacing="default">*/}
              {/*  <Button variant="secondary" onClick={onDismissRaffle}>*/}
              {/*    {t(*/}
              {/*      "features.followers.rafflePopup.actions.dismissRaffleViewerHasAlreadyJoined"*/}
              {/*    )}*/}
              {/*  </Button>*/}
              {/*</Stack>*/}
            </Stack>
          )}
          {!hasFollower && (
            <React.Fragment>
              {activeRaffle.participated && (
                <div>
                  <small>
                    {t("features.followers.rafflePopup.raffleJoinedMessage")}
                  </small>
                </div>
              )}
              <Stack horizontal spacing="default">
                <Button variant="secondary" onClick={onDismissRaffle}>
                  {t(
                    activeRaffle.participated
                      ? "features.followers.rafflePopup.actions.dismissRaffleViewerHasAlreadyJoined"
                      : "features.followers.rafflePopup.actions.dismissRaffle"
                  )}
                </Button>
                {!activeRaffle.participated && (
                  <RequiresViewerLink
                    message={t("features.followers.rafflePopup.viewerLinkCta")}
                  >
                    <Button
                      disabled={activeRaffle.participated}
                      onClick={onEnterRaffle}
                    >
                      {t(
                        activeRaffle.participated
                          ? "features.followers.rafflePopup.actions.joinRaffleViewerHasAlreadyJoined"
                          : "features.followers.rafflePopup.actions.joinRaffle"
                      )}
                    </Button>
                  </RequiresViewerLink>
                )}
              </Stack>
            </React.Fragment>
          )}
        </Stack>
      </div>
    </Flyout>
  );
};

export default Raffle;
